import {createDataStore} from './createDataStore';

// Caches /data/tensorflowData.json for the TensorFlow tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
export const useTensorflowDataStore = createDataStore(
    '/data/tensorflowData.json',
    'tensorflow-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses']
);
